export default __webpack_public_path__ + "static/as-financiering-7695c6306b221dbf6318dc3afec19d14.png";